import React, { useCallback, useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import clsx from "clsx";

import { TranslatedText } from "@plex/culture-react";
import { TranslationMgmtIcon } from "@plex/icons";
import { Link } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { DialogLink } from "ui/app/navigation";
import { Logo, MenuList, MenuTextButton } from "ui/components";
import { useUserContext, useScreenContext } from "ui/hooks";

import { TopNavigationMenu } from "./top-navigation-menu";
import { TopNavigationTenantMenu } from "./top-navigation-tenant-menu";
import styles from "./TopNavigationBar.module.scss";

export const TopNavigationBar: React.FC = () => {
  const userContext = useUserContext();
  const user = userContext.getUser();

  const screenContext = useScreenContext();

  const [isUserMenuOpened, setIsUserMenuOpened] = useState(false);

  const onUserMenuTriggered = useCallback((isOpened: boolean) => {
    setIsUserMenuOpened(isOpened);
  }, []);

  const onSignOutClick = useCallback(
    e => {
      e.preventDefault();

      userContext.signOut();
    },
    [userContext]
  );

  return (
    <nav className={styles.base}>
      <ul className={styles.navBarActions}>
        <li className={styles.navBarCompassContainer}>
          <TopNavigationMenu />
        </li>
        <li className={styles.navBarLogoContainer}>
          <RouterLink to="/">
            <Logo className={styles.navBarLogo} />
          </RouterLink>
        </li>
        {user && user.identity && (
          <>
            <li className={styles.navBarUserContainer}>
              <MenuList
                onTriggered={onUserMenuTriggered}
                anchor={
                  <MenuTextButton
                    className={clsx(styles.navBarUser, isUserMenuOpened && styles.navBarMenuOpen)}
                  >{`${user.identity.profile.firstName} ${user.identity.profile.lastName}`}</MenuTextButton>
                }
              >
                <MenuList.Item>
                  <DialogLink
                    route={{
                      to: {
                        location: "/choose-locale"
                      }
                    }}
                  >
                    <TranslatedText messageId={commonMessages.action("chooseLocale").value} />
                  </DialogLink>
                </MenuList.Item>
                <MenuList.Divider />
                <MenuList.Item>
                  <Link href="#sign-out" onClick={onSignOutClick}>
                    <TranslatedText messageId={commonMessages.action("signout").value} />
                  </Link>
                </MenuList.Item>
              </MenuList>
            </li>
            <li className={styles.navBarTenantContainer}>
              <TopNavigationTenantMenu />
            </li>
          </>
        )}
        <li className={styles.navBarTitleContainer}>
          <i className={styles.navBarTitleIcon}>
            <TranslationMgmtIcon />
          </i>
          <span className={styles.navBarTitle}>
            <TranslatedText messageId={screenContext.title.value} />
          </span>
        </li>
      </ul>
    </nav>
  );
};
